export default "__VITE_ASSET__37397968__"